<script setup>
import {download} from "@/helpers/file";

const {taskId} = defineProps(['taskId']);
const emit = defineEmits(['fileUploaded']);
import {onMounted, ref} from "vue";
import projectsTasksService from "@/services/projects-tasks.service";

const showFileUploadModal = ref(false);
const newFile = ref(null);
const files = ref([]);

onMounted(() => {
    getData();
})

async function handleFileUpload() {
    let formData = new FormData();

    for (const file of newFile.value.files) {
        if (typeof file === "object") {
            formData.append('file[]', file);
        }
    }

    await projectsTasksService.addFiles(taskId, formData);

    showFileUploadModal.value = false;
    getData();
    emit('fileUploaded');
}

async function getData() {
    const {data} = await projectsTasksService.getFiles(taskId);
    files.value = data;
}

async function downloadFile(file) {
    const {data} = await projectsTasksService.downloadFile(file.id);
    download(data, file.name);
}
</script>

<template>
    <div class="access-content__card mb-4">
        <header class="access-content__card__header">
            Attachments

            <a @click="showFileUploadModal = true" class="link">Upload</a>
        </header>

        <div class="access-content__card__content">
            <a
                v-for="file in files" :key="file.id"
                class="link-attachment mb-3"
                @click="downloadFile(file)"
            >
                <span>{{file.name}}</span>
            </a>
        </div>

        <b-modal v-model="showFileUploadModal" title="Upload File" size="md" hide-footer>
            <input
                type="file"
                multiple
                ref="newFile"
                @change="handleFileUpload"
            >
            <br>
            <br>
        </b-modal>
    </div>
</template>

<style scoped>

</style>
